import userUtil from './user/user_util';


const generateDisplay = (submittedBy) => {
  const data = submittedBy?.data;
  switch (submittedBy?.type) {
    case 'USER':
      return userUtil.getFullName(data.firstName, data.lastName);
    case 'SERVER':
      return data.serverName;
    default:
      return '';
  }
};

export default generateDisplay;
